<template>
    <div style="background-color: white; width: 100%;">
        <div style="padding: 20px 15px; font-size: 14px;">
            <div style="color: #999999;">{{info.createTime}}</div>
            <div>{{info.message}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MessageDetail",
        data() {
            return {
                id: this.$route.query.id || '',
                info: {}
            }
        },
        created() {
            this.$axios.get("/message/info", {params: {id: this.id}}).then((res) => {
                this.info = res.data;
            });
        }
    }
</script>

<style scoped>

</style>
